import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setTotals,
  resetResults,
  addResult,
  updateAllInformation,
  toggleView
} from "./actions";
import {
  convertLocationsEntitiesToPlural,
  convertLocationValueToObject
} from "./lib/utils.js";
import Menu from "./components/Menu";
import Home from "./components/Home";
import LocationsForm from "./components/LocationsForm";
import TargetsForm from "./components/TargetsForm";
import AgeForm from "./components/AgeForm";
import ReachResults from "./components/ReachResults";
import PrintPage from "./components/PrintPage";
import _ from "lodash";
import "./App.css";

const mapStateToProps = state => {
  return {
    selectedLocations: state.selectedLocations,
    selectedTargets: state.selectedTargets,
    ageRange: state.ageRange,
    currentView: state.currentView
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setTotals: value => dispatch(setTotals(value)),
    resetResults: result => dispatch(resetResults(result)),
    changePage: page => dispatch(toggleView(page)),
    updateAllInformation: data => dispatch(updateAllInformation(data)),
    addResult: result => dispatch(addResult(result))
  };
};

let totals = 0;
class AppContainer extends Component {
  componentWillReceiveProps(newProps) {
    const genders = [1, 2];
    const targets = newProps.selectedTargets.map(value =>
      value.reduce((accumulator, value) => {
        if (accumulator[value.type]) {
          accumulator[value.type] = [...accumulator[value.type], { id: value.id }];
        } else {
          accumulator[value.type] = [{id: value.id}];
        }
        return accumulator;
      }, {})
    );

    for (let i = 0; i < newProps.ageRange.length; i++) {
      genders.forEach(gender => {
        newProps.selectedLocations.map(value => {
          const type = convertLocationsEntitiesToPlural(value.type);
          const ob = convertLocationValueToObject(value);

          const params = {
            targeting_spec: JSON.stringify({
              geo_locations: { [type]: [ob] },
              age_min: newProps.ageRange[i].min,
              age_max: newProps.ageRange[i].max,
              genders: [gender],
              flexible_spec: targets
            })
          };
          const gdr = gender === 1 ? "male" : "female";
          const esc = encodeURIComponent;
          const query = Object.keys(params)
            .map(k => `${esc(k)}=${esc(params[k])}`)
            .join("&");
          this.props.setTotals(null);
          this.props.resetResults(null);
          totals = 0;
          fetch(
            `${window.config.base_url}/act_10152971550702019/reachestimate?access_token=${window.config.access_token}&${query}&locale=en_GB`
          )
            .then(response => response.json())
            .then(responseJson => {
              if (responseJson.error) {
                return;
              }
              
              totals += responseJson.data.users_upper_bound > 1000
                ? responseJson.data.users_upper_bound
                : 0;
              const result = {
                country: value.name +
                  "-" +
                  (value.region || "") +
                  "-" +
                  value.country_code,
                name: this.props.ageRange[i].min +
                  "-" +
                  this.props.ageRange[i].max,
                gender: gdr,
                reach: responseJson.data.users_upper_bound > 1000
                  ? responseJson.data.users_upper_bound
                  : 0
              };

              this.props.setTotals(totals);
              this.props.addResult(result);
            });
          return null;
        });
      });
    }
  }

  renderView() {
    switch (this.props.currentView) {
      case "home":
        return <Home />;
      case "location":
        return <LocationsForm />;
      case "target":
        return <TargetsForm />;
      case "age":
        return <AgeForm />;
      case "results":
        return <ReachResults db={this.props.db} />;
      case "print":
        return <PrintPage />;
      default:
        return <Home />;
    }
  }

  componentDidMount() {
    try {
      window.Typekit.load({ async: true })
    }catch(e){
      console.log("typekit error",e)
    }
    const query = window.location.href.split("q=");
    const id = query[1];
    fetch(`https://gruvi-settings.s3-eu-west-1.amazonaws.com/audience-calculator-settings.json?t=${Date.now()}`).then(response => response.json()).then(response => window.config = response)

    if (id) {
      this.props.db.collection("options").doc(id).get().then(doc => {
        if (doc.exists) {
          const data = doc.data();

          setTimeout(this.props.updateAllInformation(data),1000);
        } else {
          console.error("id: " + id + " doesnt exist");
        }
      });
      this.props.changePage("results");
    }
  }
  render() {
    return (
      <div>
        <Menu currentView={this.props.currentView} />
        {this.renderView()}
      </div>
    );
  }
}

const App = connect(mapStateToProps, mapDispatchToProps)(AppContainer);

export default App;



// WEBPACK FOOTER //
// ./src/App.js